import { useCallback, useState } from 'react'
import { ModalSmallCentered, ButtonsModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import TableWithoutVirtualListing from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import Checkbox from '../../../../../../forms/Checkbox'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import CustomError from '../../../../../../baseComponents/CustomError'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import { InputTableLayoutData } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'

interface ModalOrderRefundConflictsUniqueNumbersProps extends ModalOrderRefundConflictsUniqueNumbersLogicProps {}

interface ConflictUniqueNumber {
    serialCode: string
    selected: boolean
}

const ModalOrderRefundConflictsUniqueNumbers: React.FC<ModalOrderRefundConflictsUniqueNumbersProps> = ({ ...logic}) => {
    const {t, tVars} = useTwinTranslation()
    const { handleSelectUniqueNumberProduct, error, handleOnAccept, myConflict, product } = useModalOrderRefundConflictsUniqueNumbersLogic({ ...logic })
    const columns: ColumnTableSchema<ConflictUniqueNumber> = [
        {
            id: 'serialCode',
            dataKey: 'serialCode',
            label: t('serialCode', 'Código de serie'),
        },
        {
            id: 'selected',
            dataKey: 'selected',
            label: '',
            customRender: (value: any, allRowData) => <Checkbox label={''} checked={value === true} onClick={() => handleSelectUniqueNumberProduct(allRowData.absoluteIndex || allRowData.rowIndex, product)} />,
            width: 50,
        },
    ]
    return (
        <ModalSmallCentered opened={myConflict ? true : null} setOpened={() => undefined} className='flex_height'>
            <h2 className='mb-10 inline-block'><TwinTrans transKey={'chooseSerailCodeToRefund'} >Debes escoger el número de serie a devolver</TwinTrans></h2>
            <div className='text-left regular18'><TwinTrans transKey={'product'} >Producto</TwinTrans> : {myConflict?.name}</div>
            {error ? <CustomError textError={tVars('haveToChooseQuantityToRefund', 'Debes seleccionar {{quantity}} que quieres devolver', { quantity: myConflict?.quantity })} className='mt-5 text-left' /> : null}
            <div className='flex flex-col flex-auto h-1 min-h-200 mt-10'><TableWithoutVirtualListing data={myConflict?.elements} columns={columns} />
            </div>
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} setOpened={() => undefined} onCancel={() =>logic.setOpened(null)} onAccept={() => handleOnAccept(product)}  />
        </ModalSmallCentered>
    )
}

interface ModalOrderRefundConflictsUniqueNumbersLogicProps {
    conflicts: TwinDictionary
    setConflicts: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
    setCompleteData: React.Dispatch<React.SetStateAction<InputTableLayoutData | null >>
    setOpened: ModalOpenedSetTy
}

const useModalOrderRefundConflictsUniqueNumbersLogic = ({ setConflicts, setCompleteData, conflicts, setOpened }: ModalOrderRefundConflictsUniqueNumbersLogicProps) => {
    const [error, setError] = useState<boolean>(false)
    let product = Object.keys(conflicts['unique_numbers'] || {})?.[0]
    const myConflict = conflicts['unique_numbers'][product]

    const handleSelectUniqueNumberProduct = useCallback((rowIndex: any, product: string) => {
        setConflicts((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            const isSelected = copyOld?.['unique_numbers'][product]?.elements?.[rowIndex]?.selected ? true : false
            copyOld['unique_numbers'][product].elements[rowIndex]['selected'] = !isSelected
            return copyOld
        })
    }, [setConflicts])

    const getSelectedUniques = useCallback((product: string) => {
        const mySelectedUniques: TwinDictionary = []
        for (const element of myConflict.elements) {
            if (element.selected) {
                mySelectedUniques.push({ name: element.name, quantity: element.quantity, serialCode: element.serialCode, UniqueProductId: element.UniqueProductId, WarehouseId: element.WarehouseId })
            }
        }
        setCompleteData((old: any) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            const myPos = copyOld.dictPosTableData[product]
            copyOld.tableData[myPos].unique_number_selected = mySelectedUniques
            return copyOld
        })
        return mySelectedUniques
    }, [myConflict, setCompleteData])

    const handleOnAccept = useCallback((product: string) => {
        const mySelectedUniques = getSelectedUniques(product)
        let mySelectedUniquesLength = mySelectedUniques?.length
        if (parseFloat(String(mySelectedUniquesLength)) !== parseFloat(String(myConflict.quantity))) {
            setError(true)
        } else {
            setError(false)
            setConflicts((old) => {
                const copyOld = JSON.parse(JSON.stringify(old))
                delete copyOld['unique_numbers'][product]
                if (Object.keys(copyOld['unique_numbers'])?.length) {
                    return copyOld
                } else {
                    delete copyOld['unique_numbers']
                    if (Object.keys(copyOld)?.length) {
                        return copyOld
                    }
                    return null
                }
            })
            setOpened(true)
        }
    }, [setConflicts, setError, getSelectedUniques, myConflict, setOpened])


    return { handleSelectUniqueNumberProduct, error, handleOnAccept, myConflict, product }
}


export default ModalOrderRefundConflictsUniqueNumbers